<template>

    <div class="fuid-fakeinput">

        <div class="fuid-fakeinput__label"></div>
        <div class="fuid-fakeinput__input"></div>

    </div>

</template>

<script>
    export default {
        
    }
</script>